export default __webpack_public_path__ + "/dist/images/voyager-contentimg.png";